import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {initI18nLanguages} from './guards/init.guard';
import {AuthGuard} from './shared';
import {MyRedirectGuard} from './guards/my-redirect-guard.service';
import {LoginRedirectComponent} from './login-redirect/login-redirect.component';
import {LOGIN_REDIRECT_PATH} from '@shared/services/routing/login-redirect.service';

const routes: Routes = [
  {path: 'my/preferences', canActivate: [MyRedirectGuard], children: []},
  {path: 'my/integrations', canActivate: [MyRedirectGuard], children: []},
  {path: LOGIN_REDIRECT_PATH, component: LoginRedirectComponent},
  {path: 'public', loadChildren: () => import('./public/public.module').then(m => m.PublicModule)},
  {path: 'chromeless', loadChildren: () => import('./chromeless/chromeless.module').then(m => m.ChromelessModule), canActivate: [initI18nLanguages, AuthGuard]},
  {path: 'oauth', loadChildren: () => import('./oauth/oauth.module').then(m => m.OauthModule), canActivate: [initI18nLanguages, AuthGuard]},
  {path: '', loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule), canActivate: [initI18nLanguages, AuthGuard]},
  {path: '**', redirectTo: 'not-found'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
